<script>
    import Button from '../components/Button.svelte'

    const HOSPITALS_LIST = [
        { name: 'Hospital Universitario La Paz (Madrid)', url: 'https://www.comunidad.madrid/hospital/lapaz/' },
        { name: 'Hospital Gregorio Marañon (Madrid)', url: 'https://www.comunidad.madrid/hospital/gregoriomaranon/' },
        {
            name: 'Hospital Moncloa ASISA (Madrid)',
            url: 'https://www.asisa.es/hospitales-centros-oficinas/listado/madrid/madrid/hospital/clinica/2891'
        },
        { name: 'Hospital Universitario Infanta Leonor (Madrid)', url: 'https://www.comunidad.madrid/hospital/infantaleonor/' },
        {
            name: 'Hospital Clinico Universitario San Carlos (Madrid)',
            url: 'https://www.comunidad.madrid/hospital/clinicosancarlos/'
        }
    ]
</script>

<style type="text/scss">.hospitals {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.hospitals .hospital {
  background-color: #F0F3F6;
  border-radius: 2px;
  padding: 15px;
  margin-bottom: 10px;
}
/*# sourceMappingURL=src/sections/Hospitales.svelte.map */</style>

<div class="wrapper container py-10">
    <div class="content w-full">
        <h1>Hospitales</h1>
        <p>Gracias a vuestra colaboración hemos repartido pantallas entre los siguientes hospitales:</p>
        <div class="hospitals my-10">
            {#each HOSPITALS_LIST as hospital}
                <a target="_blank" href={hospital.url} class="hospital w-full md:tablet-col-4 lg:col-3">{hospital.name}</a>
            {/each}
        </div>
    </div>
</div>
